module.exports = __webpack_public_path__ + "static/media/pi.9db6b36d.svg";